import Labels from "../views/labels/labels";
import LabelsAdd from "../views/labels/labelsAdd";
import LabelsUpdate from "../views/labels/labelsUpdate";
import Artists from "../views/artists/artists";
import ArtistsAdd from "../views/artists/artistsAdd";
import ArtistsUpdate from "../views/artists/artistsUpdate";
import Accounting from "../views/accounting/accounting";
import AccountingBreakdown from "../views/accounting/accountingBreakdown";
import AddAccounting from "../views/accounting/addAccounting";
import EarningsDrilldown from "../views/earningsDrilldown/earningsDrilldown";
import Trends from "../views/trends/trends";
import Invoices from "../views/invoices/invoices";
import InvoiceAdd from "../views/invoices/invoiceAdd";
import Tracks from "../views/tracks/tracks";
import Dashboard from "../views/dashboard/dashboard";
import Promotions from "../views/promotions/promotions";
import PromotionAdd from "../views/promotions/promotionAdd";
import PromotionUpdate from "../views/promotions/promotionUpdate";
import PromoDetails from "../views/promotions/promotionDetails";
import Recipients from "../views/recipients/recipients";
import RecipientsUpdate from "../views/recipients/recipientsUpdate";
import RecipientAddNew from "../views/recipients/recipientsAdd";
import Lists from "../views/lists/lists";
import ListUpdate from "../views/lists/listUpdate";
import ListAdd from "../views/lists/listAdd";
import Releases from "../views/releases/releases";
import ReleaseForm from "../views/releases/releaseForm";
import ReleaseUpdate from "../views/releases/releaseUpdate";
import ReleaseView from "../views/releases/releaseView";
import Feature from "../views/feature/feature";
import FeatureAdd from "../views/feature/featureAdd";
import Contact from "../views/contact/contact";
import Statements from "../views/statements/statements";
import SubuserStatements from "../views/subuserStatements/subuserStatements";
import SubuserStatementsViewOnly from "../views/subuserStatements/subuserStatementsViewOnly";
import Profile from "../views/profile/profile";
import Help from "../views/help/help";
import LandingPage from "../views/Landing";
import CreateLandingPage from "../views/Landing/CreatelandingForm";
import DemoManagement from "../views/Landing/DemoManagment";
import SubmittingForm from "../views/Landing/submittingForm";
import MusicLink from "../views/musicLink";
import AddMusicLink from "../views/musicLink/musicLinkAdd";
import UpdateMusicLink from "../views/musicLink/musicLinkUpdate";
import MusicLinkUrlpart from "../views/musicLinkUrlpart";
import AddMusicLinkUrlpart from "../views/musicLinkUrlpart/add";
import MusicLinkViewStat from "../views/musicLink/viewStats";
import SubUsers from "../views/subUsers/subUsers";
import SubUsersAdd from "../views/subUsers/subUsersAdd";
import SubUsersUpdate from "../views/subUsers/subUsersUpdate";
import Mastering from "../views/mastering/mastering";
import AddMastering from "../views/mastering/addMastering";
import UpdateMastering from "../views/mastering/updateMastering";
import MasteringSongs from "../views/mastering/masteringSongs";
import SongParametersUpdate from "../views/mastering/songParametersUpdate";
import PaymentMethodAdd from "../views/paymentMethods/paymentMethodAdd";
import PaymentMethodUpdate from "../views/paymentMethods/paymentMethodUpdate";
import PaymentMethods from "../views/paymentMethods/paymentMethods";
import OrderCredits from "../views/credits/creditsOrder";
import OrderTokens from "../views/tokens/tokensOrder";

import Terms from "../views/Utils/terms";
import Policy from "../views/Utils/policy";
import { exact } from "prop-types";
import PurchaseHistory from "../views/purchaseHistory/purchaseHistory";
import ViewArtistDetails from "../views/artists/viewArtistDetails";
import ArtistsWishlist from "../views/artists/artistWishlist";
import ArtistsAddFromWishlist from "../views/artists/artistsAddFromWishlist";
import LinkLandingPageAdd from "../views/linkLandingPages/linkLandingPageAdd";
import LinkLandingPageUpdate from "../views/linkLandingPages/linkLandingPageUpdate";
import LinkLandingPages from "../views/linkLandingPages/linkLandingPages";
import LinkLandingPageAnalytics from "../views/linkLandingPages/linkLandingPageAnalytics";
import EarningsPrediction from "../views/prediction/prediction";
import DeliveryConfirmation from "../views/deliveryConfirmation/confirmation";
import Subscription from "../views/subscription/subscription";
import DeliveryConfirmationBreakdown from "../views/deliveryConfirmation/confirmationBreakdown";
import TransferRelease from "../views/releases/transferRelease";
import Tokens from "../views/tokens/tokens";
import AccessKeys from "../views/accessKeys/accessKeys";
import SubscriptionUpgrade from "../views/subscription/subscriptionUpgrade";
import UserDataForm from "../views/userDataForm/userDataForm";
import TwoFactorAuth from "../views/authentication/twoFactorAuth";
import DisputeClaims from "../views/disputeClaims/disputeClaims";
import EscrowWallet from "../views/escrowWallet/escrowWallet";
import EscrowPaymentBreakdown from "../views/escrowWallet/escrowPaymentBreakdown";
import Announcements from "../views/announcements/announcements";


var ThemeRoutes = [
  {
    path: "/releases",
    exact: true,
    name: "router.releases.view.name",
    icon: "mdi mdi-format-list-bulleted text-mmddarkblue",
    component: Releases,
    addButton: true,
    buttonText: "router.releases.view.buttonText",
    secondaryButtonText: "router.releases.view.secondaryButtonText",
    headerText: "router.releases.view.headerText"
  },
  {
    path: "/releases/add",
    name: "router.releases.add.name",
    icon: "mdi mdi-format-list-bulleted text-mmddarkblue",
    component: ReleaseForm,
    invisible: true,
    headerText: "router.releases.add.headerText"
  },
  {
    path: "/releases/:id/update/",
    name: "router.releases.update.name",
    component: ReleaseUpdate,
    invisible: true,
    headerText: "router.releases.update.headerText"
  },
  {
    path: "/releases/:id/view/",
    name: "router.releases.details.name",
    component: ReleaseView,
    invisible: true,
    headerText: "router.releases.details.headerText"
  },
  {
    path: "/releases/:id/tracks/",
    name: "router.releases.tracks.name",
    component: Tracks,
    invisible: true,
    exact: true,
    headerText: "router.releases.tracks.headerText"
  },
  {
    path: "/releases/transfer",
    name: "router.releases.transfer.name",
    component: TransferRelease,
    invisible: true,
    exact: true,
    headerText: "router.releases.transfer.headerText"
  },
  {
    path: "/releases/:id/delivered-list/",
    name: "router.releases.deliveryConfirmation.name",
    component: DeliveryConfirmation,
    invisible: true,
    exact: true,
    headerText: "router.releases.deliveryConfirmation.headerText"
  },
  {
    path: "/delivery-list/:id/view/",
    name: "router.releases.storeDeliveryList.name",
    component: DeliveryConfirmationBreakdown,
    invisible: true,
    exact: true,
    headerText: "router.releases.storeDeliveryList.headerText"
  },
  {
    path: "/copyright-infringements",
    name: "router.copyrightInfringements.view.name",
    component: DisputeClaims,
    invisible: true,
    exact: true,
    headerText: "router.copyrightInfringements.view.headerText"
  },
  {
    path: "/e-wallet",
    name: "router.escrowWallet.view.name",
    component: EscrowWallet,
    invisible: true,
    exact: true,
    headerText: "router.escrowWallet.view.headerText"
  },
    {
    path: "/e-wallet/payments/:id/view",
    name: "router.escrowWallet.breakdown.name",
    component: EscrowPaymentBreakdown,
    exact: true,
    invisible: true,
    headerText: "router.escrowWallet.breakdown.headerText"
  },
  {
    path: "/artists",
    name: "router.artists.view.name",
    icon: "mdi mdi-account-multiple text-mmddarkblue",
    component: Artists,
    addButton: true,
    exact: true,
    buttonText: "router.artists.view.buttonText",
    headerText: "router.artists.view.headerText"
  },
  {
    path: "/artists/add",
    name: "router.artists.add.name",
    component: ArtistsAdd,
    invisible: true,
    headerText: "router.artists.add.headerText"
  },
  {
    path: "/artists/:id/update/",
    name: "router.artists.update.name",
    component: ArtistsUpdate,
    invisible: true,
    headerText: "router.artists.update.headerText"
  },
  {
    path: "/artists/:id/view-details",
    name: "router.artists.viewDetails.name",
    component: ViewArtistDetails,
    exact: true,
    invisible: true,
    headerText: "router.artists.viewDetails.headerText"
  },
  {
    path: "/artists-wishlist",
    name: "router.artists.wishlist.name",
    icon: "mdi mdi-tag-heart text-mmddarkblue",
    component: ArtistsWishlist,
    exact: true,
    headerText: "router.artists.wishlist.headerText"
  },
  {
    path: "/artists-wishlist/:id/add-artist/",
    name: "router.artists.addFromWishlist.name",
    component: ArtistsAddFromWishlist,
    invisible: true,
    headerText: "router.artists.addFromWishlist.headerText"
  },

  {
    path: "/trends",
    name: "router.trends.view.name",
    icon: "mdi mdi-chart-pie text-mmddarkblue",
    component: Trends,
    headerText: "router.trends.view.headerText"
  },

  {
    path: "/earnings",
    name: "router.earningsDrilldown.view.name",
    icon: "mdi mdi-chart-areaspline text-mmddarkblue",
    component: EarningsDrilldown,
    headerText: "router.earningsDrilldown.view.headerText"
  },

  {
    path: "/accounting",
    name: "router.accounting.view.name",
    icon: "mdi mdi-calculator text-mmddarkblue",
    component: Accounting,
    headerText: "router.accounting.view.headerText",
    exact: true,
    addButton: true,
    buttonText: "router.accounting.view.buttonText",
  },

  {
    path: "/accounting/add",
    name: "router.accounting.add.name",
    component: AddAccounting,
    exact: true,
    invisible: true,
    headerText: "router.accounting.add.headerText",
  },

  {
    path: "/accounting/:id/view",
    name: "router.accounting.breakdown.name",
    component: AccountingBreakdown,
    exact: true,
    invisible: true,
    headerText: "router.accounting.breakdown.headerText"
  },

  {
    path: "/invoices",
    name: "router.invoices.view.name",
    icon: "ti ti-receipt text-mmddarkblue",
    component: Invoices,
    headerText: "router.invoices.view.headerText",
    exact: true,
    invisible: true,
    addButton: true,
    buttonText: "router.invoices.view.buttonText",
  },

  {
    path: "/invoices/add",
    name: "router.invoices.add.name",
    component: InvoiceAdd,
    invisible: true,
    headerText: "router.invoices.add.headerText",
  },
  // {
  //   path: "/landing/add",
  //   name: "Add new Landing",
  //   component: CreateLandingPage,
  //   invisible: true,
  //   headerText: "Create Landing",
  // },
  //  {
  //   invisible: false,
  //   path: "/landing",
  //   icon: "mdi mdi-playlist-play text-danger",
  //   component: LandingPage,
  //   name: "Landing Page",
  //   addButton: true,
  //   buttonText: "add new Landing Page",
  //   headerText: "Landing"
  // },
  {
    invisible: false,
    path: "/music-link",
    icon: "mdi mdi-playlist-play text-mmddarkblue",
    component: MusicLink,
    name: "router.musicLink.view.name",
    addButton: true,
    buttonText: "router.musicLink.view.buttonText",
    headerText: "router.musicLink.view.headerText",
    exact: true,
    secondaryButtonText: "router.musicLink.view.secondaryButtonText"
  },
  {
    path: "/music-link/add",
    name: "router.musicLink.add.name",
    component: AddMusicLink,
    invisible: true,
    headerText: "router.musicLink.add.headerText",
    exact: true
  },
  {
    path: "/music-link/:id/update/",
    name: "router.musicLink.update.name",
    component: UpdateMusicLink,
    exact: true,
    invisible: true,
    headerText: "router.musicLink.update.headerText"
  },
  {
    path: "/music-link/:id/view-stats",
    name: "router.musicLink.viewStats.name",
    component: MusicLinkViewStat,
    exact: true,
    invisible: true,
    headerText: "router.musicLink.viewStats.headerText"
  },
  {
    invisible: true,
    path: "/music-link-urlpart",
    icon: "mdi mdi-playlist-play text-mmddarkblue",
    component: MusicLinkUrlpart,
    name: "router.musicLinkUrlpart.view.name",
    addButton: true,
    buttonText: "router.musicLinkUrlpart.view.buttonText",
    headerText: "router.musicLinkUrlpart.view.headerText",
    exact: true,
  },
  {
    path: "/music-link-urlpart/add",
    name: "router.musicLinkUrlpart.add.name",
    component: AddMusicLinkUrlpart,
    invisible: true,
    headerText: "router.musicLinkUrlpart.add.headerText",
  },
  {
    path: "/music-link-urlpart/:id/update/",
    name: "router.musicLinkUrlpart.update.name",
    component: AddMusicLinkUrlpart,
    exact: true,
    invisible: true,
    headerText: "router.musicLinkUrlpart.update.headerText"
  },

  {
    invisible: false,
    path: "/link-landing-page",
    icon: "mdi mdi-link-variant text-mmddarkblue",
    component: LinkLandingPages,
    name: "router.linkLandingPage.view.name",
    addButton: true,
    buttonText: "router.linkLandingPage.view.buttonText",
    headerText: "router.linkLandingPage.view.headerText",
    exact: true,
  },

  {
    path: "/link-landing-page/add",
    name: "router.linkLandingPage.add.name",
    component: LinkLandingPageAdd,
    invisible: true,
    headerText: "router.linkLandingPage.add.headerText",
    exact: true
  },

  {
    path: "/link-landing-page/:id/update/",
    name: "router.linkLandingPage.update.name",
    component: LinkLandingPageUpdate,
    exact: true,
    invisible: true,
    headerText: "router.linkLandingPage.update.headerText"
  },

  {
    path: "/link-landing-page/:id/view-stats",
    name: "router.linkLandingPage.viewAnalytics.name",
    component: LinkLandingPageAnalytics,
    exact: true,
    invisible: true,
    headerText: "router.linkLandingPage.viewAnalytics.headerText"
  },

  {
    invisible: true,
    path: "/demo/:suffix?/:token?",
    component: SubmittingForm,
    name: "SubmittingForm",
    headerText: "Submitting Form"
  },
  // {
  //   invisible: false,
  //   path: "/management",
  //   icon: "mdi mdi-chart-gantt text-danger",
  //   component: DemoManagement,
  //   name: "Demo Management",
  //   headerText: "Demo Management"
  // },
  {
    path: "/mastering",
    name: "router.mastering.view.name",
    icon: "fas fa-sliders-h text-mmddarkblue",
    exact: true,
    component: Mastering,
    addButton: true,
    buttonText: "router.mastering.view.buttonText",
    headerText: "router.mastering.view.headerText",
  },
  {
    path: "/mastering/add",
    name: "router.mastering.add.name",
    component: AddMastering,
    exact: true,
    invisible: true,
    headerText: "router.mastering.add.headerText",
  },
  {
    path: "/mastering/:id/update",
    name: "router.mastering.update.name",
    component: UpdateMastering,
    exact: true,
    invisible: true,
    headerText: "router.mastering.update.headerText"
  },
  {
    path: "/mastering/:id/view",
    name: "router.mastering.viewSongs.name",
    component: MasteringSongs,
    exact: true,
    invisible: true,
    headerText: "router.mastering.viewSongs.headerText"
  },
  {
    path: "/mastering/:id/edit-parameters/",
    name: "Audio Mastering Songs",
    component: SongParametersUpdate,
    exact: true,
    invisible: true,
    headerText: "Audio Mastering Songs",
  },
  // {
  //   path: "/earnings-prediction",
  //   name: "Earnings Prediction",
  //   icon: "mdi mdi-matrix text-mmddarkblue",
  //   exact: true,
  //   component:  EarningsPrediction,
  //   headerText: "Earnings Prediction",
  // },
  // {
  //   path: "/promotions",
  //   name: "Promotions",
  //   exact: true,
  //   icon: "mdi mdi-play-circle text-mmddarkblue",
  //   component: Promotions,
  //   addButton: true,
  //   buttonText: "Add New Promotion",
  //   headerText: "Promotions"
  // },
  // {
  //   path: "/promotions/:id/view",
  //   name: "Promotion Details",
  //   component: PromoDetails,
  //   exact: true,
  //   invisible: true,
  //   headerText: "Promotions"
  // },
  // {
  //   path: "/promotions/:id/update/",
  //   name: "Update Promotion",
  //   component: PromotionUpdate,
  //   exact: true,
  //   invisible: true,
  //   headerText: "Promotions"
  // },
  // {
  //   path: "/promotions/add",
  //   name: "Add New Promotion",
  //   component: PromotionAdd,
  //   invisible: true,
  //   headerText: "Promotions"
  // },
  // {
  //   path: "/recipients",
  //   name: "Recipients",
  //   exact: true,
  //   icon: "mdi mdi-comment-account text-mmddarkblue",
  //   component: Recipients,
  //   addButton: true,
  //   buttonText: "Add New Recipient",
  //   headerText: "Recipients"
  // },

  // {
  //   path: "/recipients/:id/update/",
  //   name: "Edit Recipient",
  //   component: RecipientsUpdate,
  //   invisible: true,
  //   headerText: "Recipients",
  // },
  // {
  //   path: "/recipients/add",
  //   name: "Add New Recipient",
  //   component: RecipientAddNew,
  //   invisible: true,
  //   headerText: "Recipients",
  // },

  // {
  //   path: "/lists",
  //   name: "Lists",
  //   icon: "mdi mdi-clipboard-text text-mmddarkblue",
  //   component: Lists,
  //   exact: true,
  //   addButton: true,
  //   buttonText: "Add New List",
  //   headerText: "Lists",
  // },
  // {
  //   path: `/lists/:id/update/`,
  //   name: "Edit List",
  //   component: ListUpdate,
  //   invisible: true,
  //   headerText: "Lists",
  // },
  // {
  //   path: `/lists/add`,
  //   name: "Add New List",
  //   component: ListAdd,
  //   invisible: true,
  //   headerText: "Add New List",
  // },
  {
    path: "/feature",
    name: "router.featureRequest.view.name",
    component: Feature,
    icon: "mdi mdi-file-document-box text-mmddarkblue",
    exact: true,
    addButton: true,
    buttonText: "router.featureRequest.view.buttonText",
    headerText: "router.featureRequest.view.headerText",
  },
  {
    path: "/feature/add",
    name: "router.featureRequest.add.name",
    component: FeatureAdd,
    invisible: true,
    headerText: "router.featureRequest.add.headerText",
  },
  // {
  //   path: "/privacy-policy",
  //   exact: true,
  //   invisible: true,
  //   name: "Privacy Policy",
  //   component: Policy,
  //   headerText: "Privacy Policy"
  // },
  // {
  //   path: "/terms-and-conditions",
  //   exact: true,
  //   invisible: true,
  //   name: "Terms and Conditions",
  //   component: Terms,
  //   headerText: "Terms and Conditions"
  // },
  /*{
    link: true,
    path:
      "https://docs.google.com/forms/d/e/1FAIpQLSdMdH8cWy0ejyEZ-amMKU2oCqTrz5sQ1HaS5fjO7IYyTweIbQ/viewform",
    name: "Spotify Playlist Pitch",
    icon: "fab fa-spotify"
  },*/
  // {
  //   path: "/help",
  //   name: "Help & Contact",
  //   icon: "mdi mdi-help-circle text-warning",
  //   headerText: "Help & Contact",
  //   component: Help
  // },
  // {
  //   path: "/contact",
  //   name: "Contact & Featuring",
  //   icon: "fas fa-phone",
  //   headerText: "Contact & Featuring",
  //   component: Contact,
  //   invisible: true
  // },
  // {
  //   link: true,
  //   path: "https://forms.zohopublic.eu/movemusic/form/SoundcloudWhitelistingMusicLink/formperma/uqYjA7Gj0HhLOiLEmciPJYN3wzZE1InXyn3v_c-XChQ",
  //   name: "router.scWhitelist.view.name",
  //   icon: "mdi mdi-soundcloud text-mmddarkblue",
  // },
  {
    path: "/profile",
    name: "router.profile.view.name",
    pathTo: "/profile",
    component: Profile,
    headerText: "router.profile.view.headerText",
    invisible: true,
    exact: true
  },
  {
    path: "/announcements",
    name: "router.announcements.view.name",
    icon: "mdi mdi-bell-outline text-mmddarkblue",
    component: Announcements,
    exact: true,
    headerText: "router.announcements.view.headerText",
    invisible: true,
  },
  {
    path: "/2fa",
    name: "router.twoFactorAuthentication.view.name",
    pathTo: "/2fa",
    component: TwoFactorAuth,
    headerText: "router.twoFactorAuthentication.view.headerText",
    invisible: true,
    exact: true
  },
  {
    path: "/complete-information",
    name: "router.completeYourInformation.view.name",
    pathTo: "/complete-information",
    component: UserDataForm,
    headerText: "router.completeYourInformation.view.headerText",
    invisible: true,
    exact: true,
  },
  {
    path: "/access-keys",
    name: "router.accessKeys.view.name",
    pathTo: "/access-keys",
    component: AccessKeys,
    headerText: "router.accessKeys.view.headerText",
    invisible: true,
    exact: true
  },

  // {
  //   invisible: true,
  //   path: "/payment-methods",
  //   exact: true,
  //   name: "router.paymentMethods.view.name",
  //   component: PaymentMethods,
  //   addButton: true,
  //   buttonText: "router.paymentMethods.view.buttonText",
  //   headerText: "router.paymentMethods.view.headerText",
  // },
  // {
  //   invisible: true,
  //   path: "/payment-methods/add",
  //   name: "router.paymentMethods.add.name",
  //   component: PaymentMethodAdd,
  //   headerText: "router.paymentMethods.add.headerText",
  //   exact: true,
  // },
  
  // {
  //   invisible: true,
  //   path: "/payment-methods/:id/update/",
  //   name: "router.paymentMethods.update.name",
  //   component: PaymentMethodUpdate,
  //   headerText: "router.paymentMethods.update.headerText",
  //   exact: true,
  // },

  {
    path: "/credits/order",
    name: "router.orderCredits.view.name",
    component: OrderCredits,
    headerText: "router.orderCredits.view.headerText",
    exact: true,
    icon: "mdi mdi-cart text-mmddarkblue",
  },
  {
    path: "/tokens",
    name: "router.tokens.view.name",
    component: Tokens,
    headerText: "router.tokens.view.headerText",
    exact: true,
    icon: "mdi mdi-cart-plus text-mmddarkblue",
    invisible: true,
  },
  {
    path: "/tokens/order",
    name: "router.orderTokens.view.name",
    component: OrderTokens,
    headerText: "router.orderTokens.view.headerText",
    exact: true,
    icon: "mdi mdi-cart-plus text-mmddarkblue",
  },

  {
    invisible: true,
    path: "/purchase-history",
    exact: true,
    name: "router.purchaseHistory.view.name",
    component: PurchaseHistory,
    headerText: "router.purchaseHistory.view.headerText",
  },

  {
    invisible: true,
    path: "/subscription",
    exact: true,
    name: "router.subscription.view.name",
    component: Subscription,
    headerText: "router.subscription.view.headerText",
  },

  {
    invisible: true,
    path: "/subscription/upgrade/",
    exact: true,
    name: "router.subscription.upgrade.name",
    component: SubscriptionUpgrade,
    headerText: "router.subscription.upgrade.headerText",
  },

  {
    invisible: true,
    path: "/sub-users",
    exact: true,
    name: "router.subUsers.view.name",
    icon: "fas fa-cloud",
    component: SubUsers,
    addButton: true,
    buttonText: "router.subUsers.view.buttonText",
    headerText: "router.subUsers.view.headerText",
  },
  {
    invisible: true,
    path: "/sub-users/add",
    name: "router.subUsers.add.name",
    component: SubUsersAdd,
    headerText: "router.subUsers.add.headerText",
  },
  {
    invisible: true,
    path: "/sub-users/:id/update/",
    name: "router.subUsers.update.name",
    component: SubUsersUpdate,
    headerText: "router.subUsers.update.headerText",
  },
  {
    invisible: true,
    path: "/labels",
    exact: true,
    name: "router.labels.view.name",
    icon: "fas fa-cloud",
    component: Labels,
    addButton: true,
    buttonText: "router.labels.view.buttonText",
    headerText: "router.labels.view.headerText",
  },
  {
    invisible: true,
    path: "/labels/add",
    name: "router.labels.add.name",
    component: LabelsAdd,
    headerText: "router.labels.add.headerText",
  },
  {
    invisible: true,
    path: "/labels/:id/update/",
    name: "router.labels.update.name",
    component: LabelsUpdate,
    headerText: "router.labels.edit.headerText",
  },
  {
    invisible: true,
    path: "/statements",
    name: "router.statements.view.name",
    icon: "fas fa-cloud",
    component: Statements,
    headerText: "router.statements.view.headerText",
  },
  {
    invisible: true,
    path: "/subuser-statements",
    name: "router.subuserStatements.viewParentUser.name",
    icon: "fas fa-cloud",
    component: SubuserStatements,
    headerText: "router.subuserStatements.viewParentUser.headerText",
  },
  {
    invisible: true,
    path: "/user-statements",
    name: "router.subuserStatements.viewSubuser.name",
    icon: "fas fa-cloud",
    component: SubuserStatementsViewOnly,
    headerText: "router.subuserStatements.viewSubuser.headerText",
  },
  {
    invisible: true,
    path: "/",
    component: Dashboard,
    pathTo: "/dashboard",
    name: "router.dashboard.view.name",
    headerText: "router.dashboard.view.headerText"
  }
];
export default ThemeRoutes;